// noinspection JSUnusedGlobalSymbols

import {int, Nullable} from "./caos-def";
import {isInt} from "./utils";


/**
 * Naive check for a property on an object
 * @param data
 * @param key
 */
export function hasProperty(data: unknown, key: int|string): boolean {
    if (Array.isArray(data)) {
        if (typeof key === "string") {
            if (isInt(key)) {
                key = parseInt(key, 10);
            } else {
                return false;
            }
            return typeof data[key] !== "undefined";
        }
    }
    /* eslint-disable */
    return typeof (<any>data)[key] !== "undefined";
}


/**
 * Gets a value from an object by name
 * @param data
 * @param path
 * @param defaultValue
 */
function _getValueSimple<T>(data: unknown, path: string|int, defaultValue?: Nullable<T>): Nullable<T> {
    if (hasProperty(data, path)) {
        return defaultValue;
    }
    if (typeof path === "number") {
        if (Array.isArray(data)) {
            return data[path];
        } else {
            /* eslint-disable */
            return (<any>data)[""+path];
        }
    }
    /* eslint-disable */
    return (<any>data)[path];
}

/**
 * Gets a value by a dot delimited path.
 * Default value is only returned if a property is not set, not if it is just null
 * @param data an object to find a value for
 * @param path
 * @param defaultValue returned if property does not exist; NOT if it is just null
 */
export function getValue<T>(data: any, path: string|(string|int), defaultValue?: Nullable<T>): Nullable<T> {
    if(typeof data === "undefined") {
        return defaultValue;
    }

    if (typeof path === "number") {
        return _getValueSimple(data, path, defaultValue);
    }

    const components = path.split(".");
    let out = data;
    for (const index of components) {
        if (typeof out[index] === "undefined") {
            return defaultValue;
        }
        out = out[index];
    }
    return out;
}


/**
 * Checks if an object has a set of properties, and adds TS safeguard for the given type
 * @param obj
 * @param properties
 */
export function isObjectOfType<T>(obj: any, ...properties: string[]): obj is T {

    if (obj == null) {
        return false;
    }

    if (properties.length == 0) {
        return false;
    }

    for (const property of properties) {
        if (typeof (<any>obj)[property] === "undefined") {
            return false;
        }
    }
    return true;
}